<template>
  <div>
    <div class="wrapper">
      <div class="logo">
        <div class="refresh" @click="refresh"> <i class="el-icon-refresh"></i> </div>
        <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />
        <!-- 财务系统管理 -->
      </div>
      <div class="userInfo">
        <!-- 消息 -->
        <!-- <div class="mymessage">
          <div class="message">
            <div class="count" v-if="(count1+count2+count3)>0">{{count1+count2+count3}}</div>
            <svg-icon icon-class="message" />
            <i class="el-submenu__icon-arrow el-icon-arrow-down arrowdown"></i>
          </div>
          <div class="classification">
            <message :count1='count1' :count2='count2' :count3='count3' :messageList1="messageList1" :messageList2="messageList2"
              :messageList3="messageList3" :total="messageCount" @getMessageBox='MessageBoxUnread' />
          </div>
        </div> -->
        <!-- 消息end -->
        <div class="logout">
          <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
            <div class="avatar-wrapper">
              <div>尊敬的{{user.userName}}</div>
              <i class="el-icon-caret-bottom" />
            </div>
            <el-dropdown-menu slot="dropdown">
              <span style="display:block;" @click="changePassword">
                <el-dropdown-item>
                  修改密码
                </el-dropdown-item>
              </span>
              <span v-if="user.userType === 2" style="display:block;" @click="changeInfo">
                <el-dropdown-item>
                  修改资料
                </el-dropdown-item>
              </span>
              <span style="display:block;" @click="logout">
                <el-dropdown-item>
                  退出登录
                </el-dropdown-item>
              </span>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <changePas ref="changePasForm" :user='user' :changePasDialogShow="changePasDialogShow"
      @hideDialog="changePasDialogShow = false" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import message from '../message/message'
import Breadcrumb from '@/components/Breadcrumb'
import changePas from './changePas'
// import { getMessageBoxList } from '@/api/messageBox'
export default {
  props: {
  },
  components: {
    Breadcrumb, changePas
  },
  computed: {
    ...mapGetters(['user'])
  },
  data () {
    return {
      changePasDialogShow: false,
      changePriDialogShow: false,
      Avatar: '../../../assets/images/noinfo.png',
      noticeList: [],
      messageList: [],
      messageList1: [],
      messageList2: [],
      messageList3: [],
      messageCount: 0,
      count1: 0,
      count2: 0,
      count3: 0,
      activeName: 'first'
    }
  },
  methods: {
    changeInfo () {
      this.$router.push({ name: '/studentDetail', query: { userId: this.user.userId }, params: { orderId: this.user.userId } })
    },
    toStatistic () {
      this.$router.push({ name: 'statistic' })
    },
    changePassword () {
      this.changePasDialogShow = true
      this.$nextTick(() => {
        this.$refs['changePasForm'].$refs['changeForm'].clearValidate()
      })
    },
    changePrivacy () {
      this.changePriDialogShow = true
      this.$nextTick(() => {
        this.$refs['changePriForm'].$refs['changeForm'].clearValidate()
      })
    },
    refresh () {
      const view = this.$route
      localStorage.setItem('menuEnter', true)
      this.$store.dispatch('tagsView/delCachedView', view).then(() => {
        const { fullPath } = view
        this.$nextTick(() => {
          this.$router.replace({
            path: '/redirect' + fullPath
          })
        })
      })
    },
    MessageBoxUnread () {
      // const data1 = {
      //   msgStatus: 0,
      //   msgType: 1
      // }
      // const data2 = {
      //   msgStatus: 0,
      //   msgType: 2
      // }
      // getMessageBoxList(data1, params).then(res => {
      //   if (res.data.code === 10000) {
      //     this.messageList1 = res.data.data.list.splice(0, 6)
      //     this.count1 = parseInt(res.data.data.total)
      //   }
      // })
      // getMessageBoxList(data2, params).then(res => {
      //   if (res.data.code === 10000) {
      //     this.messageList2 = res.data.data.list.splice(0, 6)
      //     this.count2 = parseInt(res.data.data.total)
      //   }
      // })
    },
    handleClick (tab, event) {
    },
    logout () {
      this.$confirm('退出系统, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$store.dispatch('FedLogOut').then(() => {
            location.reload()
            this.$router.push({ path: '/login' })
          })

          this.$router.push({ path: '/login' })
        })
        .catch(() => {
        })
    }
  },
  created () {
    this.MessageBoxUnread()
  }

}
</script>
<style scoped lang="scss">
@import '~@/assets/styles/navbar';
@import '~@/assets/styles/theme';
.classification /deep/.el-tabs__header {
  margin: 0 0 0px;
}
.el-message-box__message p {
  color: #000;
}
.wrapper /deep/ .el-submenu__title i {
  color: #fff;
}
.wrapper {
  // background: linear-gradient(135deg, #3fc4ce, #3398cc);
  background: linear-gradient(135deg, $themeColor, $themeDeep);
  display: -ms-flexbox;
  padding: 0px;
  position: fixed;
  display: flex;
  justify-content: space-between;
  right: 0px;
  top: 0px;
  left: 0px;
  z-index: 12;
  .logo {
    margin-left: 10px;
    height: 45px;
    line-height: 45px;
    color: #fff;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: flex;
    .refresh {
      font-size: 20px;
    }
  }
  .userInfo {
    display: flex;
    font-size: 14px;
  }
  .barname,
  .logout,
  .message {
    color: #fff;
    padding-right: 5px;
    height: 45px;
    line-height: 45px;
    padding-right: 20px;
    padding-left: 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .logout {
    .avatar-container {
      margin-right: 30px;
      .avatar-wrapper {
        top: 3px;
        position: relative;
        display: flex;
        color: #fff;
        .user-avatar {
          margin-left: 10px;
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }
        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 16px;
          font-size: 12px;
        }
      }
    }
  }
  .message {
    position: relative;
    width: 32px;
    padding-left: 20px;
    .count {
      position: absolute;
      top: 5px;
      margin-left: -7px;
      left: 53%;
      font-size: 10px;
      height: 13px;
      line-height: 12px;
      font-style: normal;
      color: #e60012;
      background: #fff;
      border-radius: 7px;
      padding: 0 3px;
    }
    .arrowdown {
      right: 13px;
    }
    .svg-icon {
      font-size: 20px;
    }
  }
  .classification /deep/ .el-tabs__item:hover {
    color: $navBg;
    cursor: pointer;
  }

  .classification /deep/ .el-tabs__item.is-active {
    color: $navBg;
    border-bottom: 1px solid $navBg;
  }
  .classification /deep/.el-tabs__active-bar {
    background-color: transparent;
  }

  .mymessage:hover .classification {
    display: block;
  }
  .classification {
    display: none;
    // height: 250px;
    position: absolute;
    top: 45px;
    right: 1%;
    width: 390px;
    background: #fff;
    box-shadow: 0 2px 4px 0 rgba(216, 216, 216, 0.5);
    box-sizing: border-box;
    border: 1px solid #e7e7e7;
    .messagecount {
      list-style: none;
      position: absolute;
      box-sizing: border-box;
      li {
        width: 27px;
        display: inline-block;
        top: 12px;
        margin-left: 143px;
        left: 40%;
        font-size: 10px;
        height: 12px;
        line-height: 12px;
        font-style: normal;
        color: #fff;
        background: #e60012;
        border-radius: 7px;
        text-align: center;
        box-sizing: border-box;
      }
    }

    .messagecount li:nth-child(1) {
      margin-left: 100px;
    }
  }
  .message:hover {
    background-color: $navBgHover;
    cursor: pointer;
  }
  .logout:hover {
    background-color: $navBgHover;
    cursor: pointer;
  }
  .message:hover .arrowdown {
    transform: rotate(180deg);
  }

  .message:hover .classification {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Layout/NavigationBar/index.vue